// extracted by mini-css-extract-plugin
module.exports = {"similarJobCard":"SimilarJobsSection_similarJobCard__DpuL6","heading":"SimilarJobsSection_heading__O4i42"};